import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'first-meeting-second-step',
  templateUrl: './first-meeting-second-step.component.html',
  styleUrls: ['../../meeting-form.component.scss']
})
export class FirstMeetingSecondStepComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
